// extracted by mini-css-extract-plugin
export default {"userCell":"styles_userCell__wMlsz","truncateCell":"styles_truncateCell__V8ZBn"};